import { render, staticRenderFns } from "./insuredChangePlan.vue?vue&type=template&id=21036e12&scoped=true"
import script from "./insuredChangePlan.vue?vue&type=script&lang=js"
export * from "./insuredChangePlan.vue?vue&type=script&lang=js"
import style0 from "./insuredChangePlan.vue?vue&type=style&index=0&id=21036e12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21036e12",
  null
  
)

export default component.exports